/* eslint-disable */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Text from '@tds/core-text';
import { isEmpty, flattenDeep, isArray } from 'lodash';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import Heading from '@tds/core-heading';
import FormSummaryRow from '../formSummaryRow';
import { GroupWrapper, GroupTitle } from '../css';
import {
  CheckboxLabel,
  StyledCheckbox,
  CheckboxText
} from '../fmComponents/fmMicrosoftLicensing/css';
import {
  BACKEND_KEYS,
  additionalEquipment,
  easyAdditionalEquipment,
  oneTimeAdditionalEquipment,
  fieldWinbackFibre,
  valueNewTelusBusinessOrder,
  fieldWinback,
  contractTerm3Year,
  AccessoriesOnlyEnglish,
  AccessoriesOnlyFrench,
  accessoryValues,
  wirelessOrderDetailsSummaryOneTimeCategories,
  wlsOneTimeCategories,
  wirelessOrderDetailsSummaryMonthlyCategories,
  wlsRecurringCategories,
  sevenX
  //  accessoryValues
} from '../../utils/constant';
import { getLocalizedStrings } from '../../misc';
import { useTranslationsContext } from '../../context/TranslationsContext';
import request from '../../utils/request';
import FMProducts from './fmProducts';

const userDetailsKey = 'userDetails';
const formSectionKey = 'formSection';
const repeatedFormKey = 'repeatedForm';
const formFieldsGroup = 'formFieldsGroup';
const equipmentGroupSection = 'equipmentGroupSection';

const removePrice = label => {
  if (!label || typeof label !== 'string') return label;
  return label.replace(/\([\D\s]*\$[\d.\s\D]*\)/g, '');
};

const priceClean = label => {
  if (Array.isArray(label)) {
    return label.map(filteredLabel => {
      return removePrice(filteredLabel);
    });
  }
  return label;
};

export const getFieldLabel = (options, fieldValue) => {
  if (!options || !options.length) {
    if (Array.isArray(fieldValue)) {
      return (
        fieldValue &&
        fieldValue.length > 0 &&
        fieldValue.map(field => priceClean(field))
      );
    }
    return priceClean(fieldValue);
  }
  for (let i = 0; i < options.length; i += 1) {
    const option = options[i];
    const fields = option.fields || {};
    const { label, value } = fields || {};
    if (value === fieldValue) {
      return priceClean(label);
    }
  }

  if (Array.isArray(fieldValue) && fieldValue.length === 0) {
    return null;
  }
  return priceClean(fieldValue);
};

const profile = request.getProfile();
const { role } = (typeof profile !== 'undefined' && profile) || {};
const name = role ? role.name : null;
const OrderSummary = ({
  stepData,
  orderData,
  isFormSubmit,
  isQuestionVisible
}) => {
  const {
    contentfulValues: { yes, no }
  } = getLocalizedStrings();
  const summaryStepsData = useMemo(() => {
    const stepsData = (stepData && [...stepData]) || [];
    stepsData.splice(stepsData.length - 1, 1);
    return stepsData;
  }, stepData);

  const groupSummary = (
    fieldNamesArray,
    formStepFieldsArray,
    groupOrderData
  ) => {
    return formStepFieldsArray.map((formStepFields, index) => {
      if (!formStepFields) return null;
      const nonEmptyFields =
        formStepFields &&
        formStepFields.filter(currentField => {
          const {
            fields: { backendKey }
          } = currentField || {};
          const isObject = typeof groupOrderData[backendKey] === 'object';
          const isArray = Array.isArray(groupOrderData[backendKey]);
          if (isObject && !isArray) {
            return !!groupOrderData[backendKey].value;
          }
          if (isArray && groupOrderData[backendKey].length) {
            return true;
          }
          return !!groupOrderData[backendKey];
        });

      if (!nonEmptyFields || !nonEmptyFields.length) return null;
      const setTitle = label => {
        if (label === additionalEquipment) {
          return `${label} (${oneTimeAdditionalEquipment})`;
        }
        if (label === easyAdditionalEquipment) {
          return `${additionalEquipment} (${label})`;
        }
        return label;
      };
      return (
        <GroupWrapper style={{ marginBottom: '1em' }}>
          <GroupTitle style={{ marginBottom: '1em' }}>
            {setTitle(fieldNamesArray[index])}
          </GroupTitle>
          {nonEmptyFields &&
            nonEmptyFields.map(({ fields: { backendKey, label, options } }) => {
              let fieldValue = '';
              const isArray = Array.isArray(groupOrderData[backendKey]);
              const isObject = typeof groupOrderData[backendKey] === 'object';
              if (isObject && !isArray) {
                fieldValue = priceClean(groupOrderData[backendKey].value);
              } else if (isArray) {
                fieldValue = groupOrderData[backendKey]
                  .join(', ')
                  .split(',')
                  .map(item => priceClean(item))
                  .join(',');
              } else {
                fieldValue = priceClean(groupOrderData[backendKey]);
              }
              const labelLogic =
                fieldNamesArray[index] &&
                fieldNamesArray[index] === additionalEquipment
                  ? priceClean(label)
                  : priceClean(label);
              return (
                <FormSummaryRow
                  label={labelLogic}
                  value={getFieldLabel(options, fieldValue)}
                  isDollarRemove
                />
              );
            })}
        </GroupWrapper>
      );
    });
  };
  const handleFormSummaryRow = (
    {
      fieldLabel,
      fieldBackendKey,
      fieldName,
      formStepFields,
      contentfulId,
      formTitle,
      options: mainOptions,
      appearsAfterValue,
      appearsAfterField,
      easyPaymentFields,
      easyPaymentTitle
    },
    customOrderData
  ) => {
    const dataOrder = customOrderData || orderData;

    if (
      (fieldName === fieldWinbackFibre || fieldName === fieldWinback) &&
      dataOrder.orderType !== valueNewTelusBusinessOrder
    )
      return null;
    if (contentfulId === userDetailsKey) {
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }
    if (contentfulId === formFieldsGroup) {
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }

    if (contentfulId === formSectionKey) {
      return (
        formStepFields &&
        formStepFields.length > 0 &&
        formStepFields.map(item => {
          const {
            fields: {
              label,
              backendKey,
              name: sectionFieldName,
              fields: groupFields,
              formFields: sectionFormFields,
              title,
              formTitle: sectionFormTitle
            },
            sys: {
              contentType: {
                sys: { id: fieldContentfulId }
              }
            }
          } = item || {};
          const rowObj = {
            fieldLabel: label,
            fieldBackendKey: backendKey,
            fieldName: sectionFieldName || title,
            formStepFields: groupFields || sectionFormFields,
            contentfulId: fieldContentfulId,
            formTitle: title || sectionFormTitle
          };
          return handleFormSummaryRow(rowObj, customOrderData);
        })
      );
    }
    if (contentfulId === repeatedFormKey) {
      return (
        dataOrder[fieldName] &&
        dataOrder[fieldName].map((row, idx) =>
          groupSummary([`${formTitle} ${idx + 1}`], [formStepFields], row)
        )
      );
    }
    const fieldKey =
      (dataOrder[fieldBackendKey] && fieldBackendKey) || fieldName;
    let fieldValue = getFieldLabel(mainOptions, dataOrder[fieldKey]);

    // Check if the type can be converted to float
    let typeCheckedFieldValue = parseFloat(fieldValue);

    // Check if the value really is in decimals and needs rounding off
    if (typeCheckedFieldValue && typeCheckedFieldValue % 1 !== 0) {
      typeCheckedFieldValue = typeCheckedFieldValue.toFixed(2);
    } else if (typeof fieldValue === 'boolean') {
      typeCheckedFieldValue = fieldValue ? yes : no;
    } else {
      typeCheckedFieldValue = fieldValue;
    }

    return (
      <FormSummaryRow
        label={fieldLabel}
        value={typeCheckedFieldValue}
        isDollarRemove
      />
    );
  };
  const rowCb = (formStepFields, customOrderData) => {
    // function to replace key names in data
    const replaceKeyInArray = (array, targetKey, newKey) => {
      return array.map(obj => {
        // Destructure the object and the nestedObject property
        const { fields, ...rest } = obj;

        let updatedNestedObject = fields;

        // Rename the targetKey to newKey inside the nestedObject
        if (fields[targetKey] && obj.fields[formStepFields]) {
          updatedNestedObject = {
            ...fields,
            [newKey]: fields[targetKey]
          };
        }

        // Return the updated object with the new key name
        return { ...rest, fields: updatedNestedObject };
      });
    };

    //updatedArray holds formstepfields data without any additional objects like it's on wls OrderSummary
    const updatedArray = formStepFields
      .map(obj => {
        return obj.fields.formFields;
      })
      .flat();
    // Replace the key 'oldKey' with 'newKey' in the nested objects
    const updatedObject = replaceKeyInArray(
      updatedArray,
      'formFields',
      'fields'
    );
    return updatedArray.map(
      ({
        fields: {
          label: fieldLabel,
          outputLabel,
          backendKey: fieldBackendKey,
          formStepFields: subStepFields,
          easyPaymentFields,
          easyPaymentTitle,
          formFields: repeatedGroupFields,
          appearsAfterField,
          appearsAfterValue,
          fields: groupFields,
          name: fieldName,
          title: groupTitle,
          formTitle,
          options,
          fields
        },
        sys: {
          contentType: {
            sys: { id: contentfulId }
          }
        }
      }) => (
        <>
          {handleFormSummaryRow(
            {
              fieldLabel: outputLabel || fieldLabel,
              fieldBackendKey,
              formStepFields:
                subStepFields ||
                repeatedGroupFields ||
                groupFields ||
                formStepFields,
              fieldName: fieldName || groupTitle,
              contentfulId,
              formTitle: formTitle || groupTitle,
              options,
              appearsAfterField,
              appearsAfterValue,
              easyPaymentFields,
              easyPaymentTitle
            },
            customOrderData,
            formStepFields
          )}
        </>
      )
    );
  };

  return (
    <>
      <ExpandCollapse
        tag="h2"
        open={
          name === 'SALES_SUPPORT'
            ? [
                'productSummary',
                'customerInformationFullyManaged',
                'additionalcustomerInformationFM'
              ]
            : []
        }
      >
        {summaryStepsData &&
          summaryStepsData.map(
            ({
              fields: {
                name: stepName,
                backendKey: stepBackendKey,
                formStepFields
              }
            }) => (
              <ExpandCollapse.Panel
                id={stepBackendKey}
                header={stepName}
                key={stepBackendKey}
              >
                <>
                  {stepBackendKey === BACKEND_KEYS.officePhone &&
                    handleOfficePhone(stepName, formStepFields)}
                  {stepBackendKey === BACKEND_KEYS.wirelessOrderDetails &&
                    handleWirelessSummary(stepName, formStepFields)}
                  {![
                    BACKEND_KEYS.officePhone,
                    BACKEND_KEYS.wirelessOrderDetails
                  ].includes(stepBackendKey) &&
                    formStepFields &&
                    rowCb(formStepFields)}
                </>
              </ExpandCollapse.Panel>
            )
          )}
        <ExpandCollapse.Panel id={'productSummary'} header={'Products Summary'}>
          {orderData && <FMProducts orderData={orderData} />}
        </ExpandCollapse.Panel>
      </ExpandCollapse>
      {(isQuestionVisible === true || isQuestionVisible === false) && (
        <div style={{ padding: '20px' }}>
          <CheckboxLabel>
            <StyledCheckbox
              type="checkbox"
              id="myCheckbox"
              onClick={() => isFormSubmit(isSubmit => !isSubmit)}
            />
            <CheckboxText>
              I confirm that the correct procedure has been adhered to and a
              deal validation has been conducted
            </CheckboxText>
          </CheckboxLabel>
        </div>
      )}
    </>
  );
};

OrderSummary.propTypes = {
  stepData: PropTypes.objectOf(PropTypes.any).isRequired,
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

export default OrderSummary;
